(() => {
  'use strict';
  const openDialog = dialog => { if(dialog && !dialog.open) dialog.showModal(); };
  const closeDialog = dialog => { if(dialog?.open) dialog.close(); };
  const setupSticky = (section, actions) => {
    const sticky = section.querySelector('[data-sticky-buy]');
    if (!sticky || !actions || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      sticky.classList.toggle('is-main-visible', entries[0].isIntersecting);
    }, {rootMargin: '-96px 0px -100px 0px', threshold: 0.2});
    observer.observe(actions);
  };
  const syncFieldFocus = () => document.body.classList.toggle('is-editing-field', !!document.activeElement?.matches('input:not([type="hidden"]), textarea, select'));
  document.addEventListener('focusin', syncFieldFocus);
  document.addEventListener('focusout', () => setTimeout(syncFieldFocus, 0));
  document.addEventListener('click', event => {
    if (event.target.closest('.search-open')) openDialog(document.getElementById('SearchDialog'));
    const close = event.target.closest('.dialog-close');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target instanceof HTMLDialogElement) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target);
    }
    if (event.target.closest('.mobile-menu a')) document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
    if (!event.target.closest('.mobile-menu')) document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', event => {
    if(event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  const setupProduct = section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const form = section.querySelector('.purchase-form');
    const buttons = [...section.querySelectorAll('[data-purchase-button]')];
    const quantity = form?.querySelector('[name="quantity"]');
    const error = section.querySelector('[data-purchase-error]');
    const select = form?.querySelector('[data-variant-select]');
    let busy = false;
    let available = buttons.some(button => !button.disabled);
    let unitPrice = Number(section.dataset.priceCents);
    const formatPrice = cents => {
      const currency = section.dataset.currency || 'EGP';
      const options = currency === 'EGP' ? {minimumFractionDigits: 2, maximumFractionDigits: 2} : {style: 'currency', currency};
      const value = new Intl.NumberFormat('ar-EG-u-nu-latn', options).format(cents / 100);
      return currency === 'EGP' ? value + ' ' + section.dataset.currencyLabel : value;
    };
    const refreshButtons = () => buttons.forEach(button => {
      button.disabled = busy || !available;
      button.querySelector('[data-button-label]').textContent = !available ? section.dataset.soldOut : button.dataset.availableLabel;
    });
    const syncQuantityButtons = () => {
      if (!quantity) return;
      const count = Number(quantity.value), min = Number(quantity.min || 1);
      section.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.disabled = busy || (Number(button.dataset.quantityChange) < 0 ? count <= min : !!quantity.max && count >= Number(quantity.max));
      });
      section.querySelectorAll('[data-selection-total]').forEach(total => {
        total.textContent = quantity.checkValidity() && Number.isFinite(unitPrice) ? formatPrice(unitPrice * count) : '—';
      });
    };
    const setImage = (url, alt) => {
      const image = section.querySelector('.pdp-image');
      if (!image || !url) return;
      image.removeAttribute('srcset');
      image.src = url;
      if (alt) image.alt = alt;
      section.querySelectorAll('.pdp-thumbnail').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageUrl === url)));
    };
    section.addEventListener('click', event => {
      const stepper = event.target.closest('[data-quantity-change]');
      if (stepper && quantity && !busy) {
        if (Number(stepper.dataset.quantityChange) > 0) quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
      }
      const thumbnail = event.target.closest('.pdp-thumbnail');
      if (thumbnail) setImage(thumbnail.dataset.imageUrl, thumbnail.dataset.imageAlt);
    });
    quantity?.addEventListener('input', syncQuantityButtons);
    quantity?.addEventListener('change', syncQuantityButtons);
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      available = option.dataset.available === 'true';
      unitPrice = Number(option.dataset.priceCents);
      section.querySelectorAll('[data-product-price]').forEach(price => {price.textContent = option.dataset.price;});
      const compare = section.querySelector('[data-compare-price]');
      compare.hidden = !option.dataset.compare;
      compare.textContent = option.dataset.compare || '';
      const stock = section.querySelector('[data-product-stock]');
      stock.textContent = available ? section.dataset.inStock : section.dataset.soldOut;
      stock.classList.toggle('is-unavailable', !available);
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      }
      if (error) error.hidden = true;
      setImage(option.dataset.imageUrl);
      refreshButtons(); syncQuantityButtons();
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
    });
    form?.addEventListener('submit', async event => {
      if (event.submitter && !event.submitter.matches('[data-purchase-button]')) return;
      event.preventDefault();
      if (busy || !available || !form.reportValidity()) return;
      const buyNow = !!event.submitter?.matches('[data-buy-now]');
      const payload = new FormData(form);
      payload.delete('return_to');
      busy = true;
      form.setAttribute('aria-busy', 'true');
      error.hidden = true;
      refreshButtons(); syncQuantityButtons();
      if (select) select.disabled = true;
      if (quantity) quantity.readOnly = true;
      if (event.submitter) event.submitter.querySelector('[data-button-label]').textContent = section.dataset.busyLabel;
      try {
        const endpoint = new URL(form.action);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
        const response = await fetch(endpoint, {method:'POST', body:payload, credentials:'same-origin', headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(response.status === 422 || result.status === 422 ? section.dataset.stockError : section.dataset.errorMessage);
        location.assign(buyNow ? section.dataset.checkoutUrl : section.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message === section.dataset.stockError ? section.dataset.stockError : section.dataset.errorMessage;
        error.hidden = false;
        error.focus();
        busy = false;
        form.removeAttribute('aria-busy');
        if (select) select.disabled = false;
        if (quantity) quantity.readOnly = false;
        refreshButtons(); syncQuantityButtons();
      }
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      busy = false;
      form?.removeAttribute('aria-busy');
      if (select) select.disabled = false;
      if (quantity) quantity.readOnly = false;
      refreshButtons(); syncQuantityButtons();
    });
    syncQuantityButtons();
    setupSticky(section, section.querySelector('.pdp-actions'));
  };
  const setupCart = section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const form = section.querySelector('.cart-form');
    if (!form) return;
    const inputs = [...section.querySelectorAll('[data-cart-quantity]')];
    const status = section.querySelector('[data-cart-status]');
    const error = section.querySelector('[data-cart-error]');
    const reload = section.querySelector('[data-cart-reload]');
    const totals = [...section.querySelectorAll('[data-cart-total]')];
    totals.forEach(total => { total.dataset.original = total.textContent; });
    let busy = false, pendingCheckout = false, timer;
    const changes = () => inputs.filter(input => input.value !== input.dataset.originalQuantity);
    const sync = () => {
      const dirty = changes().length > 0;
      inputs.forEach(input => {
        input.readOnly = busy;
        input.closest('.quantity-stepper').querySelectorAll('[data-cart-step]').forEach(button => {
          button.disabled = busy || (Number(button.dataset.cartStep) < 0 ? Number(input.value) <= Number(input.min) : !!input.max && Number(input.value) >= Number(input.max));
        });
      });
      section.querySelectorAll('[data-checkout-label]').forEach(label => { label.textContent = pendingCheckout ? section.dataset.checkoutBusy : section.dataset.checkoutLabel; });
      section.querySelector('.cart-update').disabled = busy;
      form.setAttribute('aria-busy', String(busy));
      totals.forEach(total => { total.textContent = dirty || busy ? '—' : total.dataset.original; });
      if (dirty && !busy) status.textContent = section.dataset.dirty;
    };
    const save = async () => {
      clearTimeout(timer);
      if (busy) return;
      if (!form.reportValidity()) { pendingCheckout = false; sync(); return; }
      const edited = changes();
      if (!edited.length) {
        if (pendingCheckout) location.assign(section.dataset.checkoutUrl);
        else {status.textContent = ''; sync();}
        return;
      }
      busy = true;
      error.hidden = true; reload.hidden = true;
      status.textContent = section.dataset.saving;
      sync();
      const focusedId = document.activeElement?.matches('[data-cart-quantity]') ? document.activeElement.id : null;
      try {
        let result;
        for (const input of edited) {
          const payload = {line: Number(input.dataset.line), quantity: Number(input.value), sections: section.dataset.sectionId, sections_url: location.pathname};
          const response = await fetch(section.dataset.changeUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload)});
          result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(response.status === 422 || result.status === 422 ? section.dataset.stockError : section.dataset.error);
        }
        const quantitiesMatch = inputs.every(input => result.items?.[Number(input.dataset.line) - 1]?.quantity === Number(input.value));
        if (pendingCheckout && quantitiesMatch) {location.assign(section.dataset.checkoutUrl);return;}
        const html = result.sections?.[section.dataset.sectionId];
        const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
        if (!next) {location.assign(section.dataset.cartUrl);return;}
        section.replaceWith(next);
        setupCart(next);
        next.querySelector('[data-cart-status]').textContent = quantitiesMatch ? section.dataset.updated : section.dataset.stockError;
        document.querySelectorAll('.cart-count').forEach(count => {count.textContent = String(result.item_count);});
        document.querySelectorAll('.cart-link').forEach(link => {
          if (link.dataset.countLabel) link.setAttribute('aria-label', link.dataset.countLabel.replace('__COUNT__', result.item_count));
        });
        if (focusedId) document.getElementById(focusedId)?.focus({preventScroll: true});
      } catch (failure) {
        busy = false; pendingCheckout = false;
        status.textContent = '';
        error.textContent = failure.message === section.dataset.stockError ? section.dataset.stockError : section.dataset.error;
        error.hidden = false; reload.hidden = false;
        sync(); error.focus();
      }
    };
    section.addEventListener('input', event => {
      if (event.target.matches('[data-cart-quantity]')) sync();
    });
    section.addEventListener('change', event => {
      if (!event.target.matches('[data-cart-quantity]')) return;
      sync(); clearTimeout(timer); timer = setTimeout(save, 180);
    });
    section.addEventListener('click', event => {
      if (busy && event.target.closest('.cart-remove')) {event.preventDefault();return;}
      const button = event.target.closest('[data-cart-step]');
      if (!button || busy) return;
      const input = button.closest('.quantity-stepper').querySelector('input');
      if (Number(button.dataset.cartStep) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (event.submitter?.name === 'checkout') pendingCheckout = true;
      sync(); save();
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted && section.isConnected) location.assign(section.dataset.cartUrl);
    });
    sync();
    setupSticky(section, section.querySelector('.cart-summary-panel [data-cart-checkout]'));
  };
  document.querySelectorAll('[data-product-section]').forEach(setupProduct);
  document.querySelectorAll('[data-cart-section]').forEach(setupCart);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-product-section]').forEach(setupProduct);
    event.target.querySelectorAll('[data-cart-section]').forEach(setupCart);
  });
  if (!window.ELMKHBAZ_PREVIEW) return;
  const preview = window.ELMKHBAZ_PREVIEW;
  const badge = document.createElement('span'); badge.className = 'preview-mode'; badge.textContent = document.body.dataset.previewLabel; document.body.appendChild(badge);
  const showProduct = key => { const product = preview.products[key]; if(product?.url) location.assign(product.url); };
  document.addEventListener('click', event => {
    const card = event.target.closest('[data-product-preview]');
    if(card){ event.preventDefault(); showProduct(card.dataset.productPreview); }
    if(event.target.closest('.cart-link')){ event.preventDefault(); location.assign(preview.cartUrl); }
  });
  document.querySelectorAll('.search-form').forEach(form => form.addEventListener('submit', event => {
    event.preventDefault();
    const query = new FormData(form).get('q').toString().trim();
    let results=form.parentElement.querySelector('.preview-search-results');
    if(!results){results=document.createElement('div');results.className='preview-search-results';form.after(results);}
    results.replaceChildren();
    const normalize = str => str.normalize('NFKD').replace(/[\u064B-\u065F]/g,'').replace(/[أإآ]/g,'ا').toLowerCase();
    const matches=Object.entries(preview.products).filter(([,p])=>normalize(p.title+' '+p.keywords).includes(normalize(query)));
    if(!matches.length){ const p=document.createElement('p');p.textContent=document.body.dataset.searchEmpty;results.appendChild(p); }
    for(const [key,p] of matches){const btn=document.createElement('button');btn.type='button';const img=new Image();img.src=p.image;img.alt='';const span=document.createElement('span');span.textContent=p.title;btn.append(img,span);btn.addEventListener('click',()=>{closeDialog(form.closest('dialog'));showProduct(key);});results.appendChild(btn);}
  }));
})();
